import React from 'react'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import ProofOfPurchaseForm from '../../components/Form/ProofOfPurchaseForm/ProofOfPurchaseForm'
import { currentUser } from '../../redux/reducers/user.reducers'
import { popActions } from '../../redux/actions'
import support from '../../services/support.service'

class ProofOfPurchase extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      processors: [],
    }
  }

  componentDidMount = async () => {
    const { getProcessors } = this.props
    const processors = await getProcessors()
    this.setState({ processors })
  }

  render() {
    const { user } = this.props
    const { processors } = this.state
    return (
      <div className="pop-page">
        <Helmet>
          <title>Proof of Purchase</title>
          <meta name="description" content="your description" />
        </Helmet>
        <div className="container mt-5 mb-5">
          <h1 className="page-title" aria-label="Proof of Purchase">
            <FormattedMessage id="page.supportPage.proofOfPurchase.title" />
          </h1>
          <p>
            <FormattedMessage id="page.supportPage.proofOfPurchase.description" />
          </p>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <ProofOfPurchaseForm
                processors={processors}
                user={user}
                onSubmit={support.handlePoP}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: currentUser(state),
})

const mapDispatchToProps = dispatch => ({
  getProcessors: (...args) => dispatch(popActions.getProcessors(...args)),
})

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(ProofOfPurchase))
